// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let PayorV4Api = class PayorV4Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get Medical Benefits by Account identifier.
     * @param accountId Account identifier
     */
    async accountMedicalGet1(accountId) {
        const _url_ = '/payor/v4/AccountMedical/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountMedicalGet1.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountMedicalBenefitModels");
        }
        return response;
    }
    /**
     *
     * @summary Get Medical Benefits by Account and Payor identifiers.
     * @param accountId Account identifier
     * @param payorId Payor identifier
     */
    async accountMedicalGet2(accountId, payorId) {
        const _url_ = '/payor/v4/AccountMedical/{accountId}/{payorId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountMedicalGet2.');
        }
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling accountMedicalGet2.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountMedicalBenefitModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get existing Pharmacy Benefits by Account identifier.
     * @param accountId Account identifier
     */
    async accountPharmacyGet1(accountId) {
        const _url_ = '/payor/v4/AccountPharmacy/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPharmacyGet1.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountPharmacyBenefitModels");
        }
        return response;
    }
    /**
     *
     * @summary Get an existing Pharmacy Benefit by Account and Payor identifiers.
     * @param accountId Account identifier
     * @param payorId Payor identifier
     */
    async accountPharmacyGet2(accountId, payorId) {
        const _url_ = '/payor/v4/AccountPharmacy/{accountId}/{payorId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPharmacyGet2.');
        }
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling accountPharmacyGet2.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountPharmacyBenefitModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Create a new Payor.
     * @param PayorSaveModel Model containing the details to save
     */
    async payorCreateByTenantId(PayorSaveModel) {
        const _url_ = '/payor/v4/Payor';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PayorSaveModel' is not null or undefined
        if (PayorSaveModel === null || PayorSaveModel === undefined) {
            throw new Error('Required parameter PayorSaveModel was null or undefined when calling payorCreateByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PayorSaveModel, "PayorSaveModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorLongResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get an existing Payor by Tenant and Payor identifiers
     * @param payorId Payor identifier
     */
    async payorGetByTenantId(payorId) {
        const _url_ = '/payor/v4/Payor/{payorId}'
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling payorGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get existing Payor Plans by Tenant identifier and list of Payor identifiers.
     * @param PayorPlanListRequestModel PayorPlanListRequestModel object
     */
    async payorPlanListByTenantId(PayorPlanListRequestModel) {
        const _url_ = '/payor/v4/PayorPlanList';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PayorPlanListRequestModel' is not null or undefined
        if (PayorPlanListRequestModel === null || PayorPlanListRequestModel === undefined) {
            throw new Error('Required parameter PayorPlanListRequestModel was null or undefined when calling payorPlanListByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PayorPlanListRequestModel, "PayorPlanListRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorPlanModels");
        }
        return response;
    }
    /**
     *
     * @summary Search for an existing Payor.
     * @param PayorSearchModel PayorSearchModel object
     */
    async payorSearchByTenantId(PayorSearchModel) {
        const _url_ = '/payor/v4/PayorSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PayorSearchModel' is not null or undefined
        if (PayorSearchModel === null || PayorSearchModel === undefined) {
            throw new Error('Required parameter PayorSearchModel was null or undefined when calling payorSearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PayorSearchModel, "PayorSearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorSearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Update an existing Payor.
     * @param payorId Payor identifier
     * @param PayorSaveModel Model containing the details to save
     */
    async payorUpdateByTenantId(payorId, PayorSaveModel) {
        const _url_ = '/payor/v4/Payor/{payorId}'
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling payorUpdateByTenantId.');
        }
        // verify required parameter 'PayorSaveModel' is not null or undefined
        if (PayorSaveModel === null || PayorSaveModel === undefined) {
            throw new Error('Required parameter PayorSaveModel was null or undefined when calling payorUpdateByTenantId.');
        }
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PayorSaveModel, "PayorSaveModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorResponseModel");
        }
        return response;
    }
    /**
     *
     * @summary Upsearch Payor
     * @param UpsearchModelPayorPayorUpsearchModel PayorUpsearchModel object
     */
    async payorUpsearchByTenantId(UpsearchModelPayorPayorUpsearchModel) {
        const _url_ = '/payor/v4/PayorUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UpsearchModelPayorPayorUpsearchModel' is not null or undefined
        if (UpsearchModelPayorPayorUpsearchModel === null || UpsearchModelPayorPayorUpsearchModel === undefined) {
            throw new Error('Required parameter UpsearchModelPayorPayorUpsearchModel was null or undefined when calling payorUpsearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UpsearchModelPayorPayorUpsearchModel, "UpsearchModelPayorPayorUpsearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorLongResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get Plan Types
     */
    async planTypeGet() {
        const _url_ = '/payor/v4/PlanType';
        let _params_ = {};
        let _headers_ = {};
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorRoleTypeModels");
        }
        return response;
    }
};
PayorV4Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], PayorV4Api);
export { PayorV4Api };
//# sourceMappingURL=payorV4Api.js.map